import * as types from 'actions/types';

const INITIAL_STATE = {
  previousAppVersionFile: null,
  showAppVersionRefreshNotification: false,
};

const appVersion = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_PREVIOUS_APP_VERSION_FILE:
      return Object.assign({}, state, {
        previousAppVersionFile: action.versionFile,
      });
    case types.SET_SHOW_APP_VERSION_REFRESH_NOTIFICATION:
      return Object.assign({}, state, {
        showAppVersionRefreshNotification: action.value,
      });
    default:
      return state;
  }
};

export default appVersion;
